import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { CertificadosService } from 'src/app/services/certificados.service';
import { Validators, FormBuilder } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;

@Component({
    selector: "page-resumen_cert",
    templateUrl: "resumen_cert.component.html",
    styleUrls: ["resumen_cert.component.css"],
    providers: [UserService, CertificadosService]
})

export class Resumen_certComponent{

    public identity;
    public token;
   
    public rows = [];
    public actualRow;
    public matcher = new FormService();
    public corvi;
    public tipos_certificados;
     public propiedades;
   

    constructor(private fb: FormBuilder, private dialog: MatDialog,private _router: Router, private _certService: CertificadosService){
        
      /*  if(this.corvi.length > 0){
            for (let i = 0; i < this.corvi.length; i++) {
                if(this.corvi[i].tipo_permiso == "corvi"){
                    this.corvi.push(this.corvi[i]);
                }
                else if(this.corvi.length == 0 && this.corvi.length == (i+1)){
                    this.corvi = [{fecha:'',corvi:''}];

                }
            }
        }

        if(this.tipos_cert.length > 0){
            for (let i = 0; i < this.tipos_cert.length; i++) {
                if(this.tipos_cert[i] == "tipos_certificados"){
                    this.tipos_cert.push(this.tipos_cert[i]);
                }
                else if(this.tipos_cert.length == 0 && this.tipos_cert.length == (i+1)){
                    this.tipos_cert = [{fecha:'',corvi:''}];

                }
            }
        }*/

        this.ngAfterContentInit();
            
           // this.corvi = {fecha: null,corvi:''};
    }
    ngAfterContentInit(){
        if(this.corvi.length > 0){
            for (let i = 0; i < this.corvi.length; i++) {
                if(this.corvi[i].tipo_permiso == "corvi"){
                    this.corvi.push(this.corvi[i]);
                }
                else if(this.corvi.length == 0 && this.corvi.length == (i+1)){
                    this.corvi = [{fecha:'',corvi:''}];

                }
            }
        }

        if(this.tipos_certificados.length > 0){
            for (let i = 0; i < this.tipos_certificados.length; i++) {
                if(this.tipos_certificados[i] == "tipos_certificados"){
                    this.tipos_certificados.push(this.tipos_certificados[i]);
                }
                else if(this.tipos_certificados.length == 0 && this.tipos_certificados.length == (i+1)){
                    this.tipos_certificados = [{rol:'',id_direcc:'',folio:'', tipo_cert:''}];

                }
            }
        }

        if (JSON.parse(localStorage.getItem("propiedades")).length > 0){ 
            this.propiedades = JSON.parse(localStorage.getItem("propiedades"));
        }else{
            localStorage.setItem("propiedades", JSON.stringify([]))
            this.propiedades = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', direc_anexo:'', direc_anexo_num:'', loteo:'', manzana:'', plano:'', ubicacion:'', valido:'', recordId:''}]
        }
    }

    

    getResumen(){
        
    }

}